module.exports = __webpack_public_path__ + "img/new-logo.e91f1afa.svg";